module.exports = __webpack_public_path__ + "static/media/info-full-circle.74edebe6.svg";